import React from 'react';
import ReportBox from "./ReportBox";

const ReportPalletEntry = () => {
    return (
        <div>
            <ReportBox pageName="palletEntry" apiAddress="Pallet/EntryReport" title="گزارش ورود خروج"/>

        </div>
    );
};

export default ReportPalletEntry;